<app-dialog
    [title]="data.title"
    (close)="close()"
>
    <ng-container dialogContent>
    <div id="map-container"></div>
    </ng-container>
    <ng-container dialogActions>
        <fui-button
            [label]="appService.language_dictionary.system_save"
            height="mini"
            (clickEvent)="save()">
        </fui-button>
        <fui-button
            height="mini"
            color="light"
            [label]="appService.language_dictionary.system_cancel"
            (clickEvent)="close()">
        </fui-button>
    </ng-container>>
</app-dialog>
